// Feature flags. Set REFERRALS_ENABLED to true to bring Refer-a-Friend back.
export const REFERRALS_ENABLED = false;
// Set to true once ACH bank payments are fully set up in Stripe.
export const ACH_ENABLED = false;
